import { useEffect } from "react";

interface ScrollConfig {
  param: string;
  prefix: string;
}

const waitForElement = (
  elementId: string,
  delayMs = 100,
): Promise<HTMLElement> => {
  return new Promise((resolve) => {
    const tryFindElement = () => {
      const foundElement = document.getElementById(elementId);
      if (foundElement) {
        return resolve(foundElement);
      }

      setTimeout(tryFindElement, delayMs);
    };

    tryFindElement();
  });
};

const usePopStateScroll = (config: ScrollConfig) => {
  const handlePopState = async () => {
    const params = new URLSearchParams(window.location.search);
    let value = params.get(config.param);
    if (value) {
      if (config.param === "tid") {
        const parts = value.split(",");
        value = parts[parts.length - 1];
      }
      const element = await waitForElement(`${config.prefix}${value}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  useEffect(() => {
    handlePopState();
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);
};

export default usePopStateScroll;
